import { AnimationTriggerMetadata, style, transition, trigger, state, animate } from '@angular/animations';

export const removeTransition: AnimationTriggerMetadata = trigger('removeTransition', [
    transition(':enter',
        animate(400, style({opacity: 1})))
]);
